/**
 * @module mapbs.components.reportpanel.erdbebenmikrozonierung.erdbebenmikrozonierung
 */

import angular from 'angular';
import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate.js';
import olInteractionDraw from 'ol/interaction/Draw.js';
import mapbsReportservice from 'mapbs/components/reportpanel/service/reportservice.js';
import mapbsErdbebenmikrozonierungSelectionService from 'mapbs/components/reportpanel/service/erdbebenmikrozonierungselection';

const moduleErdbeben = angular.module('mapbsErdbebenmikrozonierungModule', [
    mapbsReportservice.name,
    mapbsErdbebenmikrozonierungSelectionService.name,
]);

moduleErdbeben.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/erdbebenmikrozonierung',
            require('./erdbebemikrozonierung.html')
        );
    }
);

/**
 * @type {!angular.Component}
 */
const Erdbebenmikrozonierung = {
    controller: 'mapbsErdbebenmikrozonierungController as ctrl',
    templateUrl: () => 'mapbs/erdbebenmikrozonierung',
    bindings: {
        'map': '<mapbsErdbebenmikrozonierungMap',
        'reportPanelActive': '<mapbsErdbebenmikrozonierungActive',
    },
};

moduleErdbeben.component('mapbsErdbebenmikrozonierung', Erdbebenmikrozonierung);

class ErdbebenmikrozonierungController {
    /**
   * @constructor
   * @private
   * @param {angular.Scope} $scope
   * @param {angular.$http} $http
   * @param {Reportservice} mapbsReportservice
   * @param {import('ngeo/misc/ToolActivate.js').default} ngeoToolActivateMgr
   * @param {mapbs.erdbebenmikrozonierungSelectionService} mapbsErdbebenmikrozonierungSelectionService
   * @ngInject
   */

    constructor(
        $scope,
        $http,
        mapbsReportservice,
        ngeoToolActivateMgr,
        mapbsErdbebenmikrozonierungSelectionService
    ) {
        this.scope = $scope;
        this.http = $http;
        this.reportService = mapbsReportservice;
        this.erdbebenmikrozonierungSelectionService =
      mapbsErdbebenmikrozonierungSelectionService;

        /** @type {string} */
        this.state = 'inactive';

        /** @type {string} */
        this.downloadurl = '';

        /** @type {string} */
        this.errormessage = '';

        /** @type {boolean} */
        this.reportPanelActive;

        this.erdbebenDrawinteraction = new olInteractionDraw({
            type: /** @type{import("ol/geom/GeometryType.js")} */ ('Point'),
        });

        this.erdbebenDrawinteraction.on('drawend', (event) => {
            const coord = event.feature.getGeometry();
            this.setState('waitforprint');
            this.erdbebenmikrozonierungSelectionService
        .getFeatureByCoord(coord)
        .then((response) => {
            this.handleQueryFeatureResult(response, coord);
        });
        });

        /** @type {boolean} */
        this.mapInteractionActive = false;

        ngeoToolActivateMgr.registerTool(
            'mapTools',
            new ngeoMiscToolActivate(this, 'active'),
            false
        );

        this.scope.$on('tookfocus', (event, name) => {
            if (name !== 'erdbebenmikrozonierung') {
                this.setState('inactive');
            }
        });

        this.scope.$on('opentool', (event, name) => {
            if (name === 'erdbeben') {
                this.setState('active');
            }
        });

        this.scope.$watch(
            () => this.reportPanelActive,
            (newVal) => {
                if (!newVal) {
                    this.setState('inactive');
                }
            }
        );
    }

    /**
   * handle state change from 'active' to 'inactive' and vice versa
   */
    toggleState() {
        if (this.state === 'inactive') {
            this.setState('active');
        } else {
            this.setState('inactive');
        }
    }

    setState(state) {
        this.map.removeInteraction(this.erdbebenDrawinteraction);
        switch (state) {
            case 'active':
                this.scope.$emit('takefocus', 'erdbebenmikrozonierung');
                this.map.addInteraction(this.erdbebenDrawinteraction);
                this.mapInteractionActive = true;
                break;
            case 'waitforprint':
                break;
            default:
                this.mapInteractionActive = false;
                break;
        }
        this.state = state;
    }

    /**
   * @private
   */
    handleQueryFeatureResult(features, coord) {
        if (features.length === 0) {
            this.setState('noData');
        } else if (features.length > 0) {
            this.requestReport(coord);
        }
    }

    requestReport(coord) {
        this.reportService
      .createReport(
          'erdbebenmikrozonierungs_report',
          `${coord.flatCoordinates[0]},${coord.flatCoordinates[1]}`
      )
      .then(this.reportSuccess.bind(this), this.reportError.bind(this));
    }

    reportSuccess(url) {
        this.downloadurl = url;
        this.setState('ready');
    }

    reportError(error) {
        this.errormessage = error;
        this.setState('error');
    }

    /**
   * cancel the report generation
   */
    cancelprint() {
        this.reportService.cancelReport();
    }
}

moduleErdbeben.controller(
    'mapbsErdbebenmikrozonierungController',
    ErdbebenmikrozonierungController
);

export default moduleErdbeben;
